/**
 * Mobile Image Cycling for Product Cards
 * Enhanced version with dynamic positioning
 */

window.cycleProductImages = function(button) {
  // Get button data
  const productId = button.getAttribute('data-product-id');
  const totalImages = parseInt(button.getAttribute('data-total-images'));
  const currentIndex = parseInt(button.getAttribute('data-current-index') || '0');
  
  // Find the card wrapper and media container
  const cardWrapper = button.closest('.card-wrapper');
  const mediaContainer = cardWrapper.querySelector('.card__media .media');
  
  if (!mediaContainer) {
    console.error('Media container not found');
    return;
  }
  
  const images = mediaContainer.querySelectorAll('img[data-image-index]');
  const indicators = cardWrapper.querySelector('.image-cycling-indicators');
  
  if (!images || images.length === 0) {
    console.error('No images found with data-image-index');
    return;
  }
  
  // Show indicators and shrink button on first click
  if (!button.classList.contains('active')) {
    button.classList.add('active');
    if (indicators) {
      indicators.classList.add('visible');
    }
  }
  
  // Calculate next index
  const nextIndex = (currentIndex + 1) % Math.min(totalImages, images.length);
  
  // Update all images
  images.forEach((img, index) => {
    if (index === nextIndex) {
      img.classList.remove('mobile-image-hidden');
      img.classList.add('mobile-image-visible');
    } else {
      img.classList.add('mobile-image-hidden');
      img.classList.remove('mobile-image-visible');
    }
  });
  
  // Update indicators
  if (indicators) {
    const dots = indicators.querySelectorAll('.indicator-dot');
    dots.forEach((dot, index) => {
      if (index === nextIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }
  
  // Store current index for next click
  button.setAttribute('data-current-index', nextIndex);
};

// Function to position controls based on image dimensions
function positionImageControls() {
  document.querySelectorAll('.card-wrapper').forEach(wrapper => {
    const mediaDiv = wrapper.querySelector('.card__media');
    const button = wrapper.querySelector('.mobile-image-cycling-button');
    const indicators = wrapper.querySelector('.image-cycling-indicators');
    
    if (mediaDiv && button) {
      // Get the position and dimensions of the media div
      const mediaRect = mediaDiv.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();
      
      // Calculate relative position
      const relativeTop = mediaRect.top - wrapperRect.top;
      const relativeBottom = relativeTop + mediaRect.height;
      
      // Position button at bottom-left of image
      const buttonSize = button.classList.contains('active') ? 28 : 36;
      button.style.top = (relativeBottom - buttonSize - 10) + 'px'; // 10px from bottom
      button.style.left = '10px';
      button.style.bottom = 'auto'; // Override CSS
      
      // Position indicators at bottom-center of image
      if (indicators) {
        indicators.style.top = (relativeBottom - 30) + 'px'; // Align with smaller button
        indicators.style.bottom = 'auto'; // Override CSS
      }
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  // Set initial state for all product images on mobile
  if (window.innerWidth <= 749) {
    document.querySelectorAll('.card__media .media').forEach(mediaContainer => {
      const images = mediaContainer.querySelectorAll('img[data-image-index]');
      images.forEach((img, index) => {
        if (index === 0) {
          img.classList.add('mobile-image-visible');
        } else {
          img.classList.add('mobile-image-hidden');
        }
      });
    });
    
    // Position controls after images load
    setTimeout(positionImageControls, 100);
    
    // Reposition on image load
    const images = document.querySelectorAll('.card__media img');
    images.forEach(img => {
      if (img.complete) {
        positionImageControls();
      } else {
        img.addEventListener('load', positionImageControls);
      }
    });
  }
  
  // Reposition controls on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (window.innerWidth <= 749) {
        positionImageControls();
      }
    }, 250);
  });
  
  // Reposition when new products are loaded (infinite scroll, filters, etc.)
  const observer = new MutationObserver(function(mutations) {
    if (window.innerWidth <= 749) {
      setTimeout(positionImageControls, 100);
    }
  });
  
  // Observe the collection grid for changes
  const collectionGrid = document.querySelector('#product-grid, .collection, [data-section-type="collection"]');
  if (collectionGrid) {
    observer.observe(collectionGrid, { childList: true, subtree: true });
  }
});